// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ipinfo-container {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  background: #f9fafb;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
}

.ipinfo-title {
  text-align: center;
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: #2c3e50;
}

.ipinfo-input {
  width: 100%;
  padding: 10px 14px;
  font-size: 1rem;
  border: 2px solid #bdc3c7;
  border-radius: 6px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
  resize: vertical;
}

.ipinfo-input:focus {
  border-color: #2980b9;
  outline: none;
  box-shadow: 0 0 5px rgba(41, 128, 185, 0.5);
}

.ipinfo-button {
  justify-content: center;
  margin-bottom: 20px;
  width: 100%;
  padding: 12px 0;
  background-color: #2980b9;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.ipinfo-result {
  margin-top: 20px;
  background-color: #ecf0f1;
  padding: 15px 20px;
  border-radius: 6px;
  overflow-y: auto;
  font-size: 1rem;
  color: #2c3e50;
}

.ipinfo-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid #d0d7de;
}

.ipinfo-key {
  font-weight: 600;
  color: #34495e;
  flex-basis: 40%;
  word-break: break-word;
}

.ipinfo-value {
  flex-basis: 60%;
  text-align: right;
  word-break: break-word;
  color: #2c3e50;
}

.ipinfo-error {
  background-color: #e74c3c;
  color: white;
  padding: 10px 15px;
  border-radius: 6px;
  font-weight: 600;
  text-align: center;
  margin-top: 15px;
}

/* Responsive */
@media (max-width: 480px) {
  .ipinfo-container {
    padding: 15px;
    margin: 10px;
  }
  .ipinfo-mode-buttons {
    flex-direction: column;
    gap: 10px;
  }
  .ipinfo-mode-button {
    flex: none;
    width: 100%;
  }
  .ipinfo-key,
  .ipinfo-value {
    flex-basis: 100%;
    text-align: left;
  }
  .ipinfo-row {
    flex-direction: column;
    padding: 8px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/IPInfo.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,cAAc;EAChB;AACF","sourcesContent":[".ipinfo-container {\n  max-width: 600px;\n  margin: 20px auto;\n  padding: 20px;\n  background: #f9fafb;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  color: #333;\n}\n\n.ipinfo-title {\n  text-align: center;\n  font-size: 1.8rem;\n  margin-bottom: 20px;\n  color: #2c3e50;\n}\n\n.ipinfo-input {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 1rem;\n  border: 2px solid #bdc3c7;\n  border-radius: 6px;\n  transition: border-color 0.3s ease;\n  box-sizing: border-box;\n  resize: vertical;\n}\n\n.ipinfo-input:focus {\n  border-color: #2980b9;\n  outline: none;\n  box-shadow: 0 0 5px rgba(41, 128, 185, 0.5);\n}\n\n.ipinfo-button {\n  justify-content: center;\n  margin-bottom: 20px;\n  width: 100%;\n  padding: 12px 0;\n  background-color: #2980b9;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.ipinfo-result {\n  margin-top: 20px;\n  background-color: #ecf0f1;\n  padding: 15px 20px;\n  border-radius: 6px;\n  overflow-y: auto;\n  font-size: 1rem;\n  color: #2c3e50;\n}\n\n.ipinfo-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 0;\n  border-bottom: 1px solid #d0d7de;\n}\n\n.ipinfo-key {\n  font-weight: 600;\n  color: #34495e;\n  flex-basis: 40%;\n  word-break: break-word;\n}\n\n.ipinfo-value {\n  flex-basis: 60%;\n  text-align: right;\n  word-break: break-word;\n  color: #2c3e50;\n}\n\n.ipinfo-error {\n  background-color: #e74c3c;\n  color: white;\n  padding: 10px 15px;\n  border-radius: 6px;\n  font-weight: 600;\n  text-align: center;\n  margin-top: 15px;\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .ipinfo-container {\n    padding: 15px;\n    margin: 10px;\n  }\n  .ipinfo-mode-buttons {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .ipinfo-mode-button {\n    flex: none;\n    width: 100%;\n  }\n  .ipinfo-key,\n  .ipinfo-value {\n    flex-basis: 100%;\n    text-align: left;\n  }\n  .ipinfo-row {\n    flex-direction: column;\n    padding: 8px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
